import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIGlobalRoleGetList } from './GlobalRoles.api';

export const fetchGlobalRoles = createAsyncThunk('globalRoles/fetchGlobalRoles', async () => {
    const response = await APIGlobalRoleGetList();
    return response.data;
});
